import React, { useEffect, useState } from 'react';
import { api, HERITAGE_ASSETS } from '@/lib/api';
import { Panel } from '@/components/Panel';
import { Package, ImageOff } from 'lucide-react';

export default function Bundle() {
  const [d, setD] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get('/founders/bundle'); setD(data); })(); }, []);
  if (!d) return <div style={{ color: 'var(--heritage-plum)' }}>Loading...</div>;
  const t = d.tier || {};
  const s = d.selections || {};
  const linked = t.linked_products_hydrated || [];

  return (
    <div className="space-y-6">
      <Panel className="p-8">
        <div className="h-eyebrow">My Founder Bundle</div>
        <div className="h-display text-4xl mt-1" style={{ color: 'var(--heritage-plum)' }}>{t.name}</div>
        <div className="opacity-80 mt-1 text-sm italic" style={{ color: 'var(--heritage-plum)' }}>{t.subtitle}</div>
      </Panel>

      {/* Linked products from admin */}
      {linked.length > 0 && (
        <Panel className="p-6">
          <div className="flex items-center gap-2 mb-4">
            <Package size={16} style={{ color: 'var(--heritage-plum)' }} />
            <div className="h-eyebrow">Your bundle contents</div>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {linked.map((lp) => {
              const p = lp.product;
              const img = p?.image_base64 || p?.image_url || '';
              return (
                <div key={lp.product_slug || `bundle-${lp.id || lp.name}`}
                     className="rounded-2xl overflow-hidden border flex flex-col"
                     style={{ borderColor: 'rgba(75,24,56,0.25)', background: '#FBF8F1' }}
                     data-testid={`bundle-product-${lp.product_slug}`}>
                  <div className="aspect-[4/3] w-full flex items-center justify-center" style={{ background: '#F0E9DA' }}>
                    {img ? (
                      <img src={img} alt={p?.name || lp.product_slug} className="w-full h-full object-cover" />
                    ) : (
                      <ImageOff size={26} className="opacity-40" style={{ color: 'var(--heritage-plum)' }} />
                    )}
                  </div>
                  <div className="p-4 flex-1 flex flex-col gap-1.5">
                    <div className="flex items-start justify-between gap-2">
                      <div className="h-serif text-lg leading-tight" style={{ color: 'var(--heritage-plum)' }}>
                        {p?.name || lp.product_slug}
                      </div>
                      <div className="text-xs px-2 py-0.5 rounded-full flex-shrink-0"
                           style={{ background: 'var(--heritage-plum)', color: 'var(--heritage-cream)' }}>
                        ×{lp.quantity}
                      </div>
                    </div>
                    {p?.subtitle && (
                      <div className="text-xs opacity-80 italic" style={{ color: 'var(--heritage-plum)' }}>{p.subtitle}</div>
                    )}
                    {lp.note && (
                      <div className="text-xs mt-1 opacity-90" style={{ color: 'var(--heritage-plum)' }}>
                        <span className="h-eyebrow text-[9px] mr-1">Note</span>{lp.note}
                      </div>
                    )}
                    {!p && (
                      <div className="text-[11px] italic opacity-70 mt-1" style={{ color: 'var(--heritage-plum)' }}>
                        Product details coming soon.
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Panel>
      )}

      <div className="grid md:grid-cols-2 gap-6">
        <Panel className="p-6">
          <div className="h-eyebrow mb-2">Included in your tier</div>
          <ul className="space-y-2 text-sm" style={{ color: 'var(--heritage-plum)' }}>
            {(t.inclusions || []).map((i) => <li key={i} className="flex gap-2"><span>◈</span><span>{i}</span></li>)}
            {(t.inclusions || []).length === 0 && (
              <li className="opacity-60 italic">No inclusions listed for this tier yet.</li>
            )}
          </ul>
        </Panel>
        <Panel className="p-6">
          <div className="h-eyebrow mb-2">Your selections</div>
          <ul className="space-y-2 text-sm" style={{ color: 'var(--heritage-plum)' }}>
            <li><span className="h-eyebrow inline-block w-40">Tracksuit 1</span>{s.tracksuit_1_color || 'Not selected'}</li>
            <li><span className="h-eyebrow inline-block w-40">Tracksuit 2</span>{s.tracksuit_2_color || 'Not selected'}</li>
            <li><span className="h-eyebrow inline-block w-40">Size</span>{s.tracksuit_size || 'Not set'}</li>
            <li><span className="h-eyebrow inline-block w-40">Founder Hoodie</span>{s.founder_hoodie_color || 'Not chosen'}</li>
            <li><span className="h-eyebrow inline-block w-40">Extras</span>{(s.extras || []).join(', ') || 'None yet'}</li>
          </ul>
        </Panel>
      </div>
      <Panel className="p-3 overflow-hidden">
        <img src={HERITAGE_ASSETS.editorial} alt="Bundle" className="w-full h-96 object-cover rounded-lg" />
      </Panel>
    </div>
  );
}
